import { Chain, ChainID } from '@ankr.com/chains-list';

export const isMainnetHidden = (chain: Chain) => {
  if (
    chain.id === ChainID.AVALANCHE ||
    chain.id === ChainID.HORIZEN ||
    chain.id === ChainID.TENET ||
    chain.id === ChainID.SEI ||
    chain.id === ChainID.SECRET ||
    chain.id === ChainID.FLARE ||
    chain.id === ChainID.ZKVERIFY ||
    chain.id === ChainID.TAC ||
    chain.id === ChainID.ZERO_G ||
    chain.id === ChainID.KAVA ||
    chain.id === ChainID.STELLAR ||
    chain.id === ChainID.BTC ||
    chain.id === ChainID.TON ||
    chain.id === ChainID.NERVOS ||
    chain.id === ChainID.TRON ||
    chain.id === ChainID.FUEL ||
    chain.id === ChainID.MOVEMENT_MAINNET ||
    chain.id === ChainID.CORN ||
    chain.id === ChainID.POLKADOT ||
    chain.beacons?.length ||
    chain.opnodes?.length
  ) {
    return false;
  }

  return (
    chain.paths?.length === 0 &&
    chain.type === 'mainnet' &&
    !!chain.extensions?.every(extension => !extension.paths?.length)
  );
};
